<div class="profile-header">
  <div class="profile-gradient mat-elevation-z2"></div>
  <div class="profile-image">
    <div class="clipped-background"></div>
    @if (avatarPath) {
      <img class="avatar-content" [src]="avatarPath" alt="Profile avatar" />
    } @else {
      <div
        class="avatar-content avatar-initials"
        [style.background-color]="avatarBackgroundColor"
        aria-label="Profile avatar"
        role="img"
      >
        {{ avatarInitials }}
      </div>
    }
    <button
      class="edit-avatar-button"
      mat-icon-button
      type="button"
      aria-label="Profilbild ändern"
      (click)="avatarUpload.click()"
    >
      <mat-icon>edit</mat-icon>
    </button>
  </div>
</div>

<input
  #avatarUpload
  (change)="onAvatarSelected($event)"
  accept="image/*"
  hidden
  type="file"
/>
